module.exports = __webpack_public_path__ + "media/images/case_studies/bouygues_telecom/hero-3216f584819f53f22080e45784cd0efc.svg";